module.exports = __webpack_public_path__ + "static/media/fish.ee893245.jpg";